import Mask from "./mask";

export default Mask;
